import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Header from "./src/components/CommonComponent/Header";
import { Outlet, RouterProvider, createBrowserRouter, useLocation } from "react-router-dom";
import ErrorComponent from "./src/components/CommonComponent/ErrorComponent";
import LoginPage from "./src/components/CommonComponent/Login/LoginPage";
import HomePage from "./src/components/HomePage";
import { Provider } from "react-redux";
import { store } from "./src/redux/store";
import AddUser from "./src/components/AdminComponent/AddUser";
import StudentHomePage from "./src/components/StudentComponent/StudentHomePage/StudentHomePage";
import SlotBookForm from "./src/components/StudentComponent/StudentHomePage/SlotBookForm";
import ListOfUsers from "./src/components/AdminComponent/ListOfUsers";
import EnrollStudent from "./src/components/AdminComponent/EnrollStudent";
import StudentForm from "./src/components/AdminComponent/DummyEnroll";
import useOnlineStatus from "./src/components/CommonComponent/useOnlineOffline";
import EnrolledStudentList from "./src/components/AdminComponent/EnrolledStudentList";
import MenuItems from "./src/components/AdminComponent/MenuItems";
import AvailSlot from "./src/components/AdminComponent/AvailSlot";
import BulkuploadSlots from "./src/components/AdminComponent/BulkuploadSlots";
import BulkUserUpload from "./src/components/AdminComponent/BulkUserUpload";
import AdminProfile from "./src/components/AdminComponent/AdminProfile";
import SendMailAno from "./src/components/AdminComponent/SendMailAno";
import TemplateEmail from "./src/components/EmailService/TemplateEmail";
import EmailCard from "./src/components/EmailService/EmailCard";
import EmailRecord from "./src/components/EmailService/EmailRecord";
import CustomReport from "./src/components/EmailService/CustomReport";
import AppPrivateRoute from "./AppPrivateRoute";
import EditGroup from "./src/components/AdminComponent/EditGroup";
import CreateGroup from "./src/components/AdminComponent/CreateGroup";




const AppComponent = () => {
  const handleContextMenu = (e) => {
    e.preventDefault();
    swal({
      title: "Right-clicking is disabled in this app. ",
      text: "You are not allowed to open developer tools.",
      icon: "error",
      button: "Close",
    });
  };
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [lastActivityTime, setLastActivityTime] = useState(Date.now());

  useEffect(() => {
    const activityEvents = ["mousemove", "mousedown", "keypress", "scroll"];

    const resetTimer = () => {
      setLastActivityTime(Date.now());
    };

    activityEvents.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    // Idle timeout: 24 hours (session should last at least one day)
    const IDLE_TIMEOUT_MS = 24 * 60 * 60 * 1000; // 86400000
    const checkIdleTime = () => {
      const currentTime = Date.now();
      const idleTime = currentTime - lastActivityTime;
      if (idleTime > IDLE_TIMEOUT_MS && isLoggedIn) {
        swal("Session time expire");
        localStorage.clear();
        setIsLoggedIn(false);
      }
    };

    const idleTimer = setInterval(checkIdleTime, 60000); // check every 1 minute

    return () => {
      clearInterval(idleTimer);
      activityEvents.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, [lastActivityTime, isLoggedIn]);

  const onlineStatus = useOnlineStatus();
  if (!onlineStatus) {
    swal({
      title: "OOPs no internet !",
      text: "I think you should contact your internet provider",
      icon: "error",
      buttons: false,
    });
  }

  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  return (
    <>
      <div onContextMenu={handleContextMenu}>
      
        {!isLoginPage && <Header />}
        {isLoggedIn ? <Outlet /> : <LoginPage />}
      </div>
    </>
  );
};

const appRoute = createBrowserRouter([
  {
    path: "/",
    element: <AppComponent />,
    errorElement: <ErrorComponent />,
    children: [
      {
        path: "/",
        element: (
          <AppPrivateRoute>
            <HomePage />
          </AppPrivateRoute>
        ),
      },
      {
        path: "/add-user",
        element: (
          <AppPrivateRoute>
            <AddUser />
          </AppPrivateRoute>
        ),
      },

      {
        path: "/slot-book",
        element: (
          <AppPrivateRoute>
            <StudentHomePage />
          </AppPrivateRoute>
        ),
      },
      {
        path: "/slot-book-form",
        element: (
          <AppPrivateRoute>
            <SlotBookForm />
          </AppPrivateRoute>
        ),
      },
      {
        path: "/user_table",
        element: (
          <AppPrivateRoute>
            <ListOfUsers />
          </AppPrivateRoute>
        ),
      },
      {
        path: "/enroll_student",
        element: (
          <AppPrivateRoute>
            <EnrollStudent />
          </AppPrivateRoute>
        ),
      },
      {
        path: "/dummy_enroll",
        element: (
          <AppPrivateRoute>
            <StudentForm />
          </AppPrivateRoute>
        ),
      },
      {
        path: "/profile",
        element: (
          <AppPrivateRoute>
            <AdminProfile />
          </AppPrivateRoute>
        ),
      },
      {
        path: "/enrolled_students",
        element: (
          <AppPrivateRoute>
            <EnrolledStudentList />
          </AppPrivateRoute>
        ),
      },
      {
        path: "/menu",
        element: (
          <AppPrivateRoute>
            <MenuItems />
          </AppPrivateRoute>
        ),
      },
      {
        path: "/create-slot",
        element: (
          <AppPrivateRoute>
            <AvailSlot />
          </AppPrivateRoute>
        ),
      },
      {
        path: "/email",
        element: (
          <AppPrivateRoute>
            <EmailCard />
          </AppPrivateRoute>
        ),
      },
      {
        path: "/email-temp",
        element: (
          <AppPrivateRoute>
            <TemplateEmail />
          </AppPrivateRoute>
        ),
      },
      {
        path: "/bulkUpload",
        element: (
          <AppPrivateRoute>
            <BulkuploadSlots />
          </AppPrivateRoute>
        ),
      },
      {
        path: "/bulk-user-upload",
        element: (
          <AppPrivateRoute>
            <BulkUserUpload />
          </AppPrivateRoute>
        ),
      },
      {
        path: "/email-record",
        element: (
          <AppPrivateRoute>
            <EmailRecord />
          </AppPrivateRoute>
        ),
      },
      {
        path: "/custom-report",
        element: (
          <AppPrivateRoute>
            <CustomReport />
          </AppPrivateRoute>
        ),
      },
      {
        path: "/Anonymous",
        element: (
          <AppPrivateRoute>
            <SendMailAno />
          </AppPrivateRoute>
        ),
      },
      {
        path: "/edit/:id",
        element: (
          <AppPrivateRoute>
            <EditGroup />
          </AppPrivateRoute>
        ),
      },
      {
        path: "/create-group",
        element: (
          <AppPrivateRoute>
            <CreateGroup />
          </AppPrivateRoute>
        ),
      },

      {
        path: "/login",
        element: <LoginPage />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <RouterProvider router={appRoute} />
  </Provider>
);